export default __webpack_public_path__ + "static/media/ErrorGroup.16f3b80c.svg";